'use strict';
angular.module('appQuickSignRouterModule', [])
    .config(['$stateProvider', function($stateProvider) {
        $stateProvider.state('front.editctr.app.quicksign', { // 一键快签主页
            url: '/quicksign?siteid&channelid&hasChildren',
            views: {
                'main@front.editctr': {
                    templateUrl: './editingCenter/app/quickSign/main_tpl.html',
                    controller: 'editingCenterQuickSignController'
                }
            }
        }).state('front.editctr.app.quicksign.mymanuscript', { // 关联管理模块--我的稿件
            url: '/mymanuscript',
            views: {
                'main@front.editctr': {
                    templateUrl: './editingCenter/app/quickSign/associationManage/mymanuscript/mymanuscript_tpl.html',
                    controller: 'quickSignMymanuscriptCtrl'
                }
            }
        })
            .state('front.editctr.app.quicksign.mypush', { // 关联管理模块--我的推送
                url: '/mypush',
                views: {
                    'main@front.editctr': {
                        templateUrl: './editingCenter/app/quickSign/associationManage/mypush/mypush_tpl.html',
                        controller: 'quickSignMypushCtrl'
                    }
                }
            })
            .state('front.editctr.app.quicksign.allmanuscript', { // 关联管理模块--所有稿件
                url: '/allmanuscript',
                views: {
                    'main@front.editctr': {
                        templateUrl: './editingCenter/app/quickSign/associationManage/allmanuscript/allmanuscript_tpl.html',
                        controller: 'quickSignAllmanuscriptCtrl'
                    }
                }
            })
            .state('front.editctr.app.quicksign.allpush', { // 关联管理模块--所有推送
                url: '/allpush',
                views: {
                    'main@front.editctr': {
                        templateUrl: './editingCenter/app/quickSign/associationManage/allpush/allpush_tpl.html',
                        controller: 'quickSignAllpushCtrl'
                    }
                }
            })
            .state('front.editctr.app.quicksign.manuscriptassociation', { // 审核关联模块--稿件关联
                url: '/manuscriptassociation',
                views: {
                    'main@front.editctr': {
                        templateUrl: './editingCenter/app/quickSign/auditAssociation/manuscriptAssociation/manuscriptAssociation_tpl.html',
                        controller: 'quickSignManuscriptAssociationCtrl'
                    }
                }
            })
            .state('front.editctr.app.quicksign.pushassociation', { // 审核关联模块--稿件推送
                url: '/pushassociation',
                views: {
                    'main@front.editctr': {
                        templateUrl: './editingCenter/app/quickSign/auditAssociation/pushAssociation/pushAssociation_tpl.html',
                        controller: 'quickSignPushAssociationCtrl'
                    }
                }
            })
            .state('front.editctr.app.quicksign.oneclickquicksign', { // 一键快签模块--一键快签(ismine: 1我的，0全部)
                url: '/oneclickquicksign?ismine',
                views: {
                    'main@front.editctr': {
                        templateUrl: './editingCenter/app/quickSign/oneClickQuickSign/oneClickQuickSign_tpl.html',
                        controller: 'quickSignOneClickQuickSignCtrl'
                    }
                }
            })
            .state('front.editctr.app.quicksign.operationlog', { // 操作日志模块
                url: '/operationlog',
                views: {
                    'main@front.editctr': {
                        templateUrl: './editingCenter/app/quickSign/operationLog/operationLog_tpl.html',
                        controller: 'quickSignOperationLogCtrl'
                    }
                }
            })
            .state('front.editctr.app.quicksign.issuetype', { // 签发类型模块
                url: '/issuetype',
                views: {
                    'main@front.editctr': {
                        templateUrl: './editingCenter/app/quickSign/issueType/issueType_tpl.html',
                        controller: 'quickSignIssueTypeCtrl'
                    }
                }
            })
            .state('front.editctr.app.quicksign.gjglmk', { // 签发类型模块
                url: '/gjglmk',
                views: {
                    'main@front.editctr': {
                        templateUrl: './editingCenter/app/quickSign/manuscriptAssociation/manuscriptAssociation.html',
                        controller: 'manuscriptAssociationCtrl'
                    }
                }
            });

    }]);
